import { useState } from "react";
import { FaLock, FaArrowLeft } from "react-icons/fa";
import { PROJECTS_CONSTANTS } from "../_MODULES/_API";
import { AppButton } from "../../../../../_CORE/APP/Templates/_UI/Button/_index";
import { FieldInput } from "../../../../../_CORE/APP/Templates/_UI/Form/_index";
import { API_CORE } from "../../../../../_CORE/API/ApiCORE";

export const ProjectLockScreen = ({ projectId, projectName, backTo = "/projects", onUnlocked }) => {

    const [usePin, setPin] = useState("");
    const [useError, setError] = useState(null);
    const [useIsChecking, setIsChecking] = useState(false);

    const onVerify = async () => {

        const PIN = usePin.trim();

        if (!PIN) {
            setError("Escribí el pin del proyecto");
            return;
        }

        setIsChecking(true);
        setError(null);

        const URL_RESOURCE = API_CORE.ENDPOINTS[PROJECTS_CONSTANTS.VERIFY_PIN].replace(":id", projectId);

        const RESPONSE = await API_CORE.SERVICES.POST_RESOURCE(URL_RESOURCE, { accessPin: PIN });

        setIsChecking(false);

        if (!RESPONSE?.data?.isValid) {
            setError("El pin no es correcto");
            return;
        }

        onUnlocked?.(PIN);
    };

    return (
        <div className="LStudio__app_lock">

            <div className="LStudio__app_lock_card">

                <span className="LStudio__app_lock_icon"><FaLock /></span>

                <h2 className="LStudio__app_lock_title">{projectName || "Proyecto protegido"}</h2>

                <p className="LStudio__app_lock_text">
                    Este proyecto pide un pin para abrirse. Vale también para sus subproyectos
                    y para ver las credenciales, y se mantiene hasta que cierres el navegador.
                </p>

                <FieldInput id="projectPin" type="pin" label="Pin de acceso" placeholder="••••"
                    value={usePin} error={useError}
                    onChange={(event) => setPin(event.target.value)}
                    onKeyDown={(event) => { if (event.key === "Enter") onVerify(); }} />

                <div className="LStudio__app_lock_actions">

                    <AppButton variant="ghost" tone="neutral" icon={<FaArrowLeft />} to={backTo}>Volver</AppButton>

                    <AppButton icon={<FaLock />} isLoading={useIsChecking} onClick={onVerify}>Abrir proyecto</AppButton>

                </div>

            </div>

        </div>
    );
};
